import { setShowBalances } from "@/modules/dashboard/state";
import { useAppDispatch, useAppSelector } from "@/shared/hooks/reduxHooks";

export const useShowBalance = () => {
  const dispatch = useAppDispatch();
  const showBalances = useAppSelector((state) => state.dashboard.showBalances);

  const handleShowBalances = (index: number) => {
    const newBalances = [...showBalances];
    newBalances[index] = !newBalances[index];

    dispatch(setShowBalances(newBalances));
  };

  return { handleShowBalances };
};
